/**
 * The ticket types a registration may use: the public ones. An admin-only type
 * is issued on the Tickets page; the server refuses it on every registration
 * path, the sponsors' paid seat included. Mirrors the backend's
 * `registrationTicketTypeWhere`.
 */
export const registrationTicketTypes = <T extends { isPublic?: boolean }>(rows: T[]): T[] =>
  rows.filter((row) => row.isPublic !== false);
